<template>
    <generic-block-options :block="block"
                           :hide-gradient="true"
                           :hide-text-color="true"
                           :save-url="saveUrl"
                           :has-tab-titles="hasTabTitles"
    />
</template>

<script>
    import GenericBlockOptions from './GenericBlockOptions';

    export default {
        name: 'Spacer',
        components: {
            GenericBlockOptions,
        },
        props: {
            block: {
                type: Object,
                required: true,
            },
            saveUrl: {
                type: String,
                required: true,
            },
            hasTabTitles: {
                type: Boolean,
                default: () => true,
            }
        },
    };
</script>
